import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
// import PropTypes from 'prop-types';
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Images from "../Assets/Images";
import Api from "../Services/Api";
import "../Styles/Login.scss";
import { Link } from "react-router-dom";
import MicrosoftLogin from "react-microsoft-login";
import { ssoClientId } from "../Services/Config";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../Action/login";
import { history } from "../Routes/history";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import AuthContext from "../Context/AuthContext";

import CircularProgress from "@material-ui/core/CircularProgress";

class Login extends Component {
  static contextType = AuthContext;
  
  constructor(props) {
    super(props);

    this.state = {
      TenantKey: null,
      userName: "",
      password: "",
      submitted: false,
      errors: {},
      showLoader: true,
      PasswordVisibility: false,
    };
    this.authHandler = this.authHandler.bind(this);
  }

 

  componentDidMount() {
    // Set auth context for the login action
    const { setAuthContext } = require('../Action/login');
    setAuthContext(this.context);
    
    secureLocalStorage.clear();
    let tenantKey = this.props.match.params.id;
    if (tenantKey != undefined) {
      secureLocalStorage.setItem("tenantKey", tenantKey);
      const { actions } = this.props;
      actions.tenantKey(tenantKey);
    }

    let path=this.props.match.path;
    if(path=='/tenant/:id'){
      secureLocalStorage.setItem("loggedClient", "tenant");
    }else{
      secureLocalStorage.setItem("loggedClient", "user");
    }

    setTimeout(() => {
      this.setState({showLoader:false})},
      1000
    );
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.loggedInStatus != null) {
      nextProps.history.push("/superadmin/home");
      return { null: nextProps.actions.LoginSatus(null) };
    }
    if (nextProps.tenantLoggedInStatus != null) {
      nextProps.history.push(`/tenant/${nextProps.tenantKey}/home/main`);
      return { null: nextProps.actions.tenantKey(null) };
    }
    if (nextProps.userLoggedInStatus != null) {
      nextProps.history.push(`/user/${nextProps.tenantKey}/home/main`);
      return { null: nextProps.actions.userLoginStatus(null) };
    }
    if (nextProps.resetpasswordLoginStatus != null) {
      nextProps.history.push(`/user/${nextProps.tenantKey}/changepassword`);
      return { null: nextProps.actions.ResetPasswordLoginStatus(null) };
    }
    if (nextProps) return null;
  }

  handleUserName = (e) => {
    const { actions } = this.props;
    let Name = e.target.value;
    actions.userName(Name);
  };

  handlePassword = (e) => {
    const { actions } = this.props;
    let pwd = e.target.value;
    actions.passWord(pwd);
  };

  handleCheck() {
    
  }

  

  async authHandler(err, data) {
    const { login } = this.context;
    
    if (data) {
      var request = {
        Name: data.authResponseWithAccessToken.account.name,
        Role: "SSO USER",
        Telephone: "12345",
        EmailAddress: data.authResponseWithAccessToken.account.userName,
        Password: "password",
      };

      let response = await Api.userAddViaSSO(request);
      if (response.status === 200 || response.token) {
        toast.success(response.message);
        let token = "Bearer" + " " + response.token;
        
        // Update auth context
        login({
          userKey: secureLocalStorage.getItem("tenantKey"),
          userName: data.authResponseWithAccessToken.account.name,
          loggedClient: "user",
          role: "SSO USER"
        });
        
        // Still update localStorage for backward compatibility
        secureLocalStorage.setItem("authToken", token);
        secureLocalStorage.setItem("userKey", secureLocalStorage.getItem("tenantKey"));
        secureLocalStorage.setItem("loggedClient", "user");
        secureLocalStorage.setItem(
          "userName",
          data.authResponseWithAccessToken.account.name
        );
        
      } else {
        toast.error(response.message);
        this.props.history.push(`/user/${secureLocalStorage.getItem("tenantKey")}`);
      }
    } else {
      toast.error("Error in SSO Login");
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({
      submitted: true,
    });
    const { actions, UserName, PassWord, tenantKey } = this.props;

    if (tenantKey === null) {
      if (UserName && PassWord) {
        let params = {
          
          userName: UserName,
          password: PassWord,
        };
        actions.superAdminLogin(params);
      } else {
        toast.error("Please enter values in all fields.");
      }
    } else {
      if (UserName && PassWord && tenantKey) {
        let params = {
          tenantEmail: UserName,
          password: PassWord,
          TenantKey: tenantKey,
          
        };
        actions.TenantLogin(params);
      } else {
        toast.error("Please enter values in all fields.");
      }
    }
  };

  render() {
    const { UserName, PassWord, tenantKey, loaderStatus } = this.props;
    let tenantKeys = this.props.match.params.id;
    // const {UserName,PassWord} =this.props
    const { errors } = this.state;
    let Auth = secureLocalStorage.getItem("isAuthorised");
    
    return (
      <div className="auth-wrapper">

{/* showLoader */}
          {this.state.showLoader 
          ?<div className="LoaderContainer">
            <CircularProgress style={{'color': '#FFFFFF'}} size={60}/>
          </div> 
         :""}
        <div className="auth-inner">
          <div className="authCont">
            <div className="logo">
              <img src={Images.RISKWELLLOGO} alt="Logo" width="200" />
            </div>
            <form onSubmit={(e) => this.handleSubmit(e)} autoComplete="new-password">
              <h3>Sign In</h3>
              {/* <p>Please login to your account</p> */}
              <div className="form-group">
                {/* <label></label> */}
                <div className="ip-field1">
                  <input
                    type="email"
                    autoComplete="off"
                    name="userName"
                    value={UserName}
                    onChange={this.handleUserName}
                    placeholder="User Name"
                    
                    className={
                      "form-control " +
                      (this.state.submitted && UserName != ""
                        ? errors.userName
                        : "")
                    }
                  />
                  {this.state.submitted && UserName === "" && (
                    <div className="invalid-feedback">
                      User Name is required
                    </div>
                  )}
                  <span>
                    <img src={Images.USER} alt="User" width="17" />
                  </span>
                </div>
              </div>

              <div className="form-group">
                {/* <label>Password</label> */}
                <div className="ip-field1">
                  <input
                    type={this.state.PasswordVisibility==true ?"text":"password"}
                    name="password"
                    value={PassWord}
                    onChange={this.handlePassword}
                    placeholder="Password"
                    className={
                      "form-control " +
                      (this.state.submitted && PassWord != ""
                        ? errors.password
                        : "")
                    }
                  />
                  {this.state.submitted && PassWord === "" && (
                    <div className="invalid-feedback">Password is required</div>
                  )}
                  <span style={{width: "fit-content"}}>
                    <img src={Images.PASSWORD} alt="Password" width="17" />
                  </span>
                  <span  style={{display:"inline-block",right:"5px",position:"absolute"}}
                  onClick={()=>this.setState({PasswordVisibility:!this.state.PasswordVisibility})}>
                    {
                      this.state.PasswordVisibility?<VisibilityOutlinedIcon htmlColor="#005f62"/>:<VisibilityOffOutlinedIcon htmlColor="#005f62"/>
                    }
                  </span>
                 
                </div>
              </div>
             

              <div className="form-group">
                <div className="d-flex">
                  <div className="custom-control custom-checkbox">
                    
                  </div>
                  <div className="ml-auto">
                    <p className="forgot-password text-right">
                     
                      <Link
                        to={{
                          pathname: `/${tenantKeys}/forgotPassword`,
                          state: window.location.pathname,
                        }}
                      >
                        Forgot Password?
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              

              <button
                type="submit"
                className="btn btn-primary btn-block btn-rounded relPosition"
              >
                Sign In
                {loaderStatus ? (
                  <span className="MatBtnSpinner">
                    <CircularProgress style={{ color: "#FFFFFF" }} size={22} />
                  </span>
                ) : null}
              </button>
              {tenantKey ? (
                <div className="orDivider">
                  <span>Or</span>
                </div>
              ) : (
                ""
              )}
              <ul className="singleSignOn">
               
                {tenantKey ? (
                  <MicrosoftLogin
                    clientId={ssoClientId}
                    authCallback={this.authHandler}
                    redirectUri={window.location.origin}
                    prompt="login"
                    buttonTheme="dark_short"
                  />
                ) : (
                  ""
                )}

                
              </ul>
             
            </form>
          </div>
          <ToastContainer />
        </div>
      </div>
    );
  }
}

Login.defaultProps = {
  userName: {},
  password: {},
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    UserName: state.login.userName,
    PassWord: state.login.password,
    loggedInStatus: state.login.loginStatus,
    tenantKey: state.login.tenantKey,
    tenantLoggedInStatus: state.login.tenantLoginStatus,
    userLoggedInStatus: state.login.userLoginStatus,
    loaderStatus: state.login.loaderStatus,
    resetpasswordLoginStatus:state.login.resetpasswordLoginStatus,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
